
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agence-immobiliere-maroc",
      function () {
        return require("private-next-pages/agence-immobiliere-maroc/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agence-immobiliere-maroc"])
      });
    }
  